import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'

/**
 * Standardized version of the job title. In other words, you may have many job
 * titles that are effectively the same type.
 */
export enum JobType {
  PrincipalInvestigator = 'pi',
}
// Needs to be before namespace is defined
const JOB_TYPES: ReadonlySet<JobType> = new Set(
  Object.values(JobType) as JobType[],
)
export namespace JobType {
  export const ALL: readonly JobType[] = Array.from(JOB_TYPES)
  export const isJobType = TypeChecker.Factory.oneOf(JOB_TYPES)
  export const assertIsJobType: TypeAsserter<JobType> =
    TypeAsserter.Factory.from(isJobType)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link JobType}
   */
  export function getEntry(
    jobType: JobType,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[jobType], id: jobType }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    JobType,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [JobType.PrincipalInvestigator]: {
      name: 'Principal Investigator',
    },
  }
}
